import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check, PencilLine } from "lucide-react";
import { useContent } from "@/context/ContentContext";

// While editing, clicks on editable text must not trigger the link/button around it.
function useClickGuard(active) {
  useEffect(() => {
    if (!active) return undefined;
    const guard = (e) => {
      const host = e.target.closest?.("a, button");
      if (!host || host.closest("[data-cms-img]")) return;
      const typing = document.activeElement?.closest?.("[data-cms]");
      if (e.target.closest("[data-cms]") || (typing && host.contains(typing))) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("click", guard, true);
    return () => document.removeEventListener("click", guard, true);
  }, [active]);
}

export function EditBar() {
  const { editing, exit } = useContent();
  useClickGuard(editing);
  if (!editing) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] w-[calc(100%-2rem)] max-w-xl rounded-2xl sm:rounded-full bg-ink text-cream shadow-2xl px-4 py-3 flex items-center gap-3" data-testid="edit-bar">
      <PencilLine className="h-5 w-5 text-gold shrink-0" />
      <p className="text-xs sm:text-sm text-cream/85 flex-1">Editing mode. Click any outlined text to change it, or use <b>Change photo</b> on images. Changes save automatically.</p>
      <Link to="/admin" className="hidden sm:inline text-xs text-cream/70 hover:text-cream underline" data-testid="edit-bar-admin-link">Admin</Link>
      <button onClick={exit} data-testid="edit-bar-done-btn" className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-terra text-paper px-4 py-2 text-sm font-semibold">
        <Check className="h-4 w-4" /> Done
      </button>
    </div>
  );
}
